import React from 'react';
import { CarouselSnap, CarouselInfinite } from '../Carousel';
import { MEDIUM_BREAKPOINT, LARGE_BREAKPOINT } from '../modular-grid/constants';

interface CategoryCarouselProps {
  component_type: string;
  componentToRender: React.ReactNode[];
  windowWidth: number;
  autoplay?: number;
  renderedBannerSlidesAmount: number;
  percentageWidth: number;
}

const CategoryCarousel: React.FC<CategoryCarouselProps> = ({
  component_type,
  componentToRender,
  windowWidth,
  autoplay,
  renderedBannerSlidesAmount,
  percentageWidth,
}) => {
  const shouldBeInfinite =
    component_type === 'banner' && windowWidth >= MEDIUM_BREAKPOINT.min;

  return (
    <>
      {shouldBeInfinite ? (
        <CarouselInfinite
          specifiedSlidesAmount={renderedBannerSlidesAmount}
          autoplay={autoplay}
        >
          {componentToRender}
        </CarouselInfinite>
      ) : (
        <CarouselSnap
          visiblePartLeft={30}
          visiblePartRight={20}
          specifiedSlidesAmount={renderedBannerSlidesAmount}
          lastItemPercentageWidth={percentageWidth}
          edgeSlidesPadding={windowWidth >= LARGE_BREAKPOINT.min ? 8 : 7}
          {...(component_type === 'banner' ? { autoplay } : {})}
        >
          {componentToRender}
        </CarouselSnap>
      )}
    </>
  );
};

export default CategoryCarousel;
